import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Paper,
  Grid,
  Button,
  FormControlLabel,
  Checkbox,
  Avatar,
  Snackbar,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Card,
  CardMedia,
  CardContent,
  Stack,
  Chip
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PhotoLibraryIcon from '@mui/icons-material/PhotoLibrary';
import URLManager from '../funcionalidadeNavbar/URLManager';

export default function TesteCalcePublic(){
  const { id } = useParams();
  const navigate = useNavigate();
  const _url = URLManager.getBaseURL();

  const [item, setItem] = useState(null);
  const [flags, setFlags] = useState({});
  const [imageDialog, setImageDialog] = useState({ open: false, src: '', title: '' });
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({ open:false, severity: 'info', message: '' });
  // Nomes legíveis para cada área testada (substitui "Imagem 1/2/..")
  const imageLabels = ['Traseira', 'Solado', 'Bico', 'Flexao', 'Peito do Pé'];
  // Cores correspondentes para cada área (com bom contraste)
  const imageColors = ['#0ea5e9', '#16a34a', '#f97316', '#ef4444', '#7c3aed'];

  useEffect(()=>{
    if (!id) return;
  fetch(`${_url}/teste-calce/${id}`)
      .then(r => r.json())
      .then(data => {
        setItem(data);
        // initialize flags from data if present (support new backend names)
        const keys = [
          'img1_incomodando_calcanhar','img1_saindo_do_pe_ao_andar','img1_descolando_parte_traseira_da_sola','img1_normal',
          'img2_incomodando_frente','img2_incomodando_centro_do_pe','img2_incomodando_parte_de_tras','img2_solado_descolando','img2_normal',
          'img3_apertado','img3_pressionando_dedos','img3_solado_descolando_no_bico','img3_normal',
          'img4_incomodando_flexao','img4_cabedal_nao_flexiona','img4_solado_descolando_na_area_da_felxao','img4_normal',
          'img5_entrada_do_pe_com_dificuldade','img5_apertando_peito_pe','img5_folgado_peito_pe','img5_normal'
        ];
        const initial = {};
        keys.forEach(k => initial[k] = !!data[k]);
        setFlags(initial);
      }).catch(e=> setSnackbar({ open:true, severity:'error', message:'Erro ao carregar teste' }));
  },[id, _url]);

  const handleFlag = (k, v) => setFlags(prev => ({...prev, [k]: v}));

  const openImage = (src, title='Imagem') => {
    if (!src) return;
    setImageDialog({ open: true, src, title });
  };
  const closeImage = () => setImageDialog({ open: false, src: '', title: '' });

  const handleSubmit = async () => {
    if (!item) return;
    setLoading(true);
    try{
      const payload = { id: item.id, ...flags };
  const res = await fetch(`${_url}/teste-calce/avaliar`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      if (!res.ok) {
        const txt = await res.text();
        setSnackbar({ open:true, severity:'error', message: txt || 'Erro' });
      } else {
        setSnackbar({ open:true, severity:'success', message: 'Avaliação enviada. Obrigado!' });
        setTimeout(()=> navigate('/'), 1200);
      }
    }catch(e){
      setSnackbar({ open:true, severity:'error', message: 'Erro ao enviar' });
    }finally{ setLoading(false); }
  };

  if (!item) return <Box sx={{p:3}}><Typography>Carregando...</Typography></Box>;

  return (
    <Box sx={{ p:3, background: 'linear-gradient(180deg, #f6f9ff 0%, #ffffff 60%)', minHeight: '100vh' }}>
      <Paper sx={{ p:0, overflow: 'hidden' }} elevation={1}>
        <Box sx={{ background: 'linear-gradient(90deg,#0f172a,#1e293b)', color: '#fff', p:3 }}>
          <Typography variant="h5" sx={{ fontWeight: 800 }}>{item.produtoNomeModelo}</Typography>
          <Typography variant="body2" sx={{ opacity: 0.9 }}>Ref: {item.produtoReferencia || '—'}</Typography>
        </Box>

        <Box sx={{ p:3 }}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
              <Paper sx={{ p:2, textAlign: 'center', bgcolor: '#fff' }} elevation={2}>
                <Box sx={{ width: '100%', height: 240, display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#f7fafc', borderRadius: 1, overflow: 'hidden' }}>
                  {item.produtoImageUrl ? (
                    <Box component="img" src={item.produtoImageUrl} alt={item.produtoNomeModelo} sx={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
                  ) : (
                    <Avatar variant="rounded" sx={{ width: 160, height: 160, bgcolor: '#e2e8f0' }} />
                  )}
                </Box>
                <CardContent>
                  <Typography variant="h6">{item.nome || 'Testador'}</Typography>
                  <Typography variant="body2" color="text.secondary">Telefone: {item.telefoneWhatsapp || '—'}</Typography>
                </CardContent>
                <Stack direction="row" spacing={1} justifyContent="center" sx={{ mt:1 }}>
                  <Chip label={`Pé: ${item.numeracaoPe || '—'}`} size="small" />
                  <Chip label={`Teste ID: ${item.id}`} size="small" />
                </Stack>
              </Paper>
            </Grid>

            <Grid item xs={12} md={8}>
              <Grid container spacing={2}>
                {[1,2,3,4,5].map(i => (
                  <Grid item xs={12} sm={6} key={i}>
                    <Card elevation={2} sx={{ position: 'relative' }}>
                      <CardContent sx={{ p: 1 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                          <Chip label={imageLabels[i-1] || `Imagem ${i}`} size="small" sx={{ backgroundColor: imageColors[i-1] || undefined, color: '#fff', fontWeight: 700 }} />
                          <Typography variant="subtitle2" sx={{ color: 'text.secondary', fontWeight: 600 }}>{/* espaço para subtítulo futuro */}</Typography>
                        </Box>
                        {item[`imagem${i}`] ? (
                          <Box sx={{ width: '100%', height: 200, display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#fbfdff', borderRadius: 1, overflow: 'hidden' }}>
                            <CardMedia component="img" image={item[`imagem${i}`]} alt={imageLabels[i-1] || `img${i}`} sx={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                          </Box>
                        ) : (
                          <Box sx={{ height: 200, display:'flex', alignItems:'center', justifyContent:'center', color:'#9ca3af', bgcolor:'#fbfbfb', borderRadius:1 }}>Sem imagem</Box>
                        )}

                        <Box sx={{ mt:1, display: 'flex', flexDirection: 'column' }}>
                          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', mb: 1 }}>
                            <Button startIcon={<PhotoLibraryIcon />} size="small" onClick={() => openImage(item[`imagem${i}`], imageLabels[i-1] || `Imagem ${i}`)} disabled={!item[`imagem${i}`]}>Visualizar</Button>
                          </Box>
                          <Box>
                            {i===1 && (
                                <>
                                  <FormControlLabel control={<Checkbox checked={flags.img1_incomodando_calcanhar} onChange={e=>handleFlag('img1_incomodando_calcanhar', e.target.checked)} />} label="Incomodando calcanhar" />
                                  <FormControlLabel control={<Checkbox checked={flags.img1_saindo_do_pe_ao_andar} onChange={e=>handleFlag('img1_saindo_do_pe_ao_andar', e.target.checked)} />} label="Saindo do pé ao andar" />
                                  <FormControlLabel control={<Checkbox checked={flags.img1_descolando_parte_traseira_da_sola} onChange={e=>handleFlag('img1_descolando_parte_traseira_da_sola', e.target.checked)} />} label="Descolando parte traseira da sola" />
                                  <FormControlLabel control={<Checkbox checked={flags.img1_normal} onChange={e=>handleFlag('img1_normal', e.target.checked)} />} label="Normal" />
                                </>
                            )}
                            {i===2 && (
                              <>
                                <FormControlLabel control={<Checkbox checked={flags.img2_incomodando_frente} onChange={e=>handleFlag('img2_incomodando_frente', e.target.checked)} />} label="Incomodando frente" />
                                <FormControlLabel control={<Checkbox checked={flags.img2_incomodando_centro_do_pe} onChange={e=>handleFlag('img2_incomodando_centro_do_pe', e.target.checked)} />} label="Incomodando centro do pé" />
                                <FormControlLabel control={<Checkbox checked={flags.img2_incomodando_parte_de_tras} onChange={e=>handleFlag('img2_incomodando_parte_de_tras', e.target.checked)} />} label="Incomodando parte de trás" />
                                <FormControlLabel control={<Checkbox checked={flags.img2_solado_descolando} onChange={e=>handleFlag('img2_solado_descolando', e.target.checked)} />} label="Solado descolando" />
                                <FormControlLabel control={<Checkbox checked={flags.img2_normal} onChange={e=>handleFlag('img2_normal', e.target.checked)} />} label="Normal" />
                              </>
                            )}
                            {i===3 && (
                              <>
                                <FormControlLabel control={<Checkbox checked={flags.img3_apertado} onChange={e=>handleFlag('img3_apertado', e.target.checked)} />} label="Apertado" />
                                <FormControlLabel control={<Checkbox checked={flags.img3_pressionando_dedos} onChange={e=>handleFlag('img3_pressionando_dedos', e.target.checked)} />} label="Pressionando dedos" />
                                <FormControlLabel control={<Checkbox checked={flags.img3_solado_descolando_no_bico} onChange={e=>handleFlag('img3_solado_descolando_no_bico', e.target.checked)} />} label="Solado descolando no bico" />
                                <FormControlLabel control={<Checkbox checked={flags.img3_normal} onChange={e=>handleFlag('img3_normal', e.target.checked)} />} label="Normal" />
                              </>
                            )}
                            {i===4 && (
                              <>
                                <FormControlLabel control={<Checkbox checked={flags.img4_incomodando_flexao} onChange={e=>handleFlag('img4_incomodando_flexao', e.target.checked)} />} label="Incomodando flexão" />
                                <FormControlLabel control={<Checkbox checked={flags.img4_cabedal_nao_flexiona} onChange={e=>handleFlag('img4_cabedal_nao_flexiona', e.target.checked)} />} label="Cabedal não flexiona" />
                                <FormControlLabel control={<Checkbox checked={flags.img4_solado_descolando_na_area_da_felxao} onChange={e=>handleFlag('img4_solado_descolando_na_area_da_felxao', e.target.checked)} />} label="Solado descolando na área da flexão" />
                                <FormControlLabel control={<Checkbox checked={flags.img4_normal} onChange={e=>handleFlag('img4_normal', e.target.checked)} />} label="Normal" />
                              </>
                            )}
                            {i===5 && (
                              <>
                                <FormControlLabel control={<Checkbox checked={flags.img5_entrada_do_pe_com_dificuldade} onChange={e=>handleFlag('img5_entrada_do_pe_com_dificuldade', e.target.checked)} />} label="Entrada do pé com dificuldade" />
                                <FormControlLabel control={<Checkbox checked={flags.img5_apertando_peito_pe} onChange={e=>handleFlag('img5_apertando_peito_pe', e.target.checked)} />} label="Apertando no peito do pé" />
                                <FormControlLabel control={<Checkbox checked={flags.img5_folgado_peito_pe} onChange={e=>handleFlag('img5_folgado_peito_pe', e.target.checked)} />} label="Folgado no peito do pé" />
                                <FormControlLabel control={<Checkbox checked={flags.img5_normal} onChange={e=>handleFlag('img5_normal', e.target.checked)} />} label="Normal" />
                              </>
                            )}
                          </Box>
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>

              <Box sx={{ mt:2 }}>
                <Button variant="contained" onClick={handleSubmit} disabled={loading}>{loading? 'Enviando...' : 'Enviar avaliação'}</Button>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Paper>

      <Dialog open={imageDialog.open} onClose={closeImage} maxWidth="md" fullWidth>
        <DialogTitle sx={{ m:0, p:1 }}>{imageDialog.title}
          <IconButton aria-label="close" onClick={closeImage} sx={{ position: 'absolute', right: 8, top: 8 }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ p:0, background: '#111' }}>
          {imageDialog.src ? <Box component="img" src={imageDialog.src} alt={imageDialog.title} sx={{ width: '100%', height: 'auto', maxHeight: '80vh', objectFit: 'contain', display: 'block' }} /> : null}
        </DialogContent>
      </Dialog>

      <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={()=>setSnackbar(s => ({...s, open:false}))}>
        <Alert severity={snackbar.severity}>{snackbar.message}</Alert>
      </Snackbar>
    </Box>
  );
}
